import * as React from 'react';
import { Container, Input, Row, Spacer, Table } from '@nextui-org/react';

export interface AppFilterableListItem {
  id: string;
  name: string;
  selected: boolean;
}

interface AppFilterableListProps {
  items: AppFilterableListItem[];
  onItemsSelect: (selectedItems?: AppFilterableListItem[]) => void;
  title: string;
}

/**
 * @name AppFilterableList
 * @description tbd...
 */
export function AppFilterableList(props: AppFilterableListProps) {
  const { items, onItemsSelect, title } = props;

  // TODO:
  // 1. filter only the unselected items
  // 3. always show the selected items first in the list

  // Setup
  const selectedItems = items.filter((i) => i.selected).map((i) => i.id);

  // Handlers
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectionChanged = (selectedKeys: any) => {
    if (selectedKeys === 'all') {
      onItemsSelect(items);
      return;
    }

    // Kind of annoying using this Selection type which is a Set.
    const keys = Array.from(selectedKeys.keys());

    // Because we are calling the set selected items every time, we are going to
    // re-render the component with a new list. We send all the keys each time.
    const selectedItems = items.filter((item) => keys.includes(item.id));
    onItemsSelect(selectedItems);
  };

  return (
    <Container>
      <Row>
        <Input placeholder="Filter..." disabled={true} fullWidth={true} />
      </Row>
      <Spacer />
      <Row>
        <Table
          aria-label="Multiple selection table"
          containerCss={{
            borderRadius: 0,
            boxShadow: 'none',
            height: 'auto',
            minWidth: '100%',
          }}
          css={{ p: 0 }}
          selectionMode="multiple"
          showSelectionCheckboxes={true}
          onSelectionChange={onSelectionChanged}
          selectedKeys={selectedItems}
        >
          <Table.Header>
            <Table.Column>{title}</Table.Column>
          </Table.Header>
          <Table.Body>
            {items.map((item) => (
              <Table.Row key={item.id}>
                <Table.Cell>{item.name}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Row>
    </Container>
  );
}
